import { authHttp } from '../http'
import * as routes from '../../routes/ordem-coleta.routes'
import {
  urlAjustarQuantidadeSobra,
  urlAprovarOrdemColeta,
  urlAssociarSobraComOrdemColeta,
  urlDesassociarSobraComOrdemColeta,
  urlDownloadNfDevolucaoParcial,
  urlDownloadNfDevolucaoTotal,
  urlGetOrdensColetaParaAprovar,
  urlLocalDescarga,
  urlSolicitarCorrecaoOrdemColeta,
} from '../../routes/ordem-coleta.routes'
import { errorHandler } from '../../../util/error.service'
import { urlAtualizarDeliveryInvoicePathAndNumber } from '../../routes/receive-vehicle.routes'
import { getEmpresas, getTps } from '../../../localstorage/localstorage.service'
import { downloadZipFile } from '../../../util/download.service'
import { urlGetInfoForAnaliseDasOcorrencias } from '../../routes/ordem-coleta.routes'

// ***** Ordem Coleta *****
export async function salvarOrdemColeta({
  tp_id,
  descricao,
  company_id,
  local_descarga_id,
  observacoes,
}) {
  try {
    const response = await authHttp().post(routes.urlOrdemColeta, {
      tp_id,
      descricao,
      company_id,
      local_descarga_id,
      observacoes,
    })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function atualizarOrdemColeta({
  id,
  tp_id,
  descricao,
  justificativa_correcao,
  status,
  company_id,
  local_descarga_id,
  observacoes,
}) {
  try {
    const response = await authHttp().put(routes.urlOrdemColeta, {
      tp_id,
      descricao,
      justificativa_correcao,
      company_id,
      local_descarga_id,
      id,
      status,
      observacoes,
    })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getOrdensColeta(tp_id, operationcenter_ids, pInicial, pFinal) {
  try {
    const response = await authHttp().get(
      routes.urlGetOrdensColeta(tp_id, operationcenter_ids, pInicial, pFinal),
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function visualizarOrdemColeta(ordemcoleta_id) {
  try {
    const response = await authHttp().get(routes.urlVisualizarOrdemColeta(ordemcoleta_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function imprimirOrdemColeta(ordemcoleta_id) {
  try {
    const response = await authHttp().get(routes.urlImprimirOrdemColeta(ordemcoleta_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function gerarExcelOrdemColeta(ordemcoleta_id) {
  try {
    const response = await authHttp().get(routes.urlGerarExcelOrdemColeta(ordemcoleta_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function finalizarOrdemColeta(ordemcoleta_id) {
  try {
    const response = await authHttp().get(routes.urlFinalizarOrdemColeta(ordemcoleta_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function coletarOrdemColeta(ordemcoleta_id) {
  try {
    const response = await authHttp().put(routes.urlColetarOrdemColeta(ordemcoleta_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function apagarOrdemColeta(ordemcoleta_id) {
  try {
    const response = await authHttp().put(routes.urlApagarOrdemColeta(ordemcoleta_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

// ***** Ocorrência *****
export async function getDevolucaoParcialPendentes(tp_id, company_id, pInicial, pFinal) {
  try {
    const response = await authHttp().get(
      routes.urlGetDevolucaoParcialPendentes(tp_id, company_id, pInicial, pFinal),
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getDevolucaoParcialAssociadas(ordemcoleta_id) {
  try {
    const response = await authHttp().get(routes.urlGetDevolucaoParcialAssociadas(ordemcoleta_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getDevolucaoTotalPendentes(tp_id, company_id, pInicial, pFinal) {
  try {
    const response = await authHttp().get(
      routes.urlGetDevolucaoTotalPendentes(tp_id, company_id, pInicial, pFinal),
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getDevolucaoTotalAssociadas(ordemcoleta_id) {
  try {
    const response = await authHttp().get(routes.urlGetDevolucaoTotalAssociadas(ordemcoleta_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function atualizarNumNfEntrega(num_nf, delivery_id) {
  try {
    const response = await authHttp().put(routes.urlAtualizarNumNFEntrega(num_nf, delivery_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function atualizarSenhaDeColeta(invoice_id, senha) {
  try {
    const response = await authHttp().put(routes.urlAtualizarSenhaDeColeta(invoice_id, senha))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function atualizarSenhaDeColetaDevolucaoTotal(delivery_id, senha) {
  try {
    const response = await authHttp().put(
      routes.urlAtualizarSenhaDeColetaDevolucaoTotal(delivery_id, senha),
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function atualizarDeliveryInvoicePathAndNumber(delivery_id, path, invoice_number) {
  try {
    const response = await authHttp().put(urlAtualizarDeliveryInvoicePathAndNumber(delivery_id), {
      path,
      invoice_number,
    })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function buscarNotaCliente(invoice_number, delivery_step_id) {
  try {
    const response = await authHttp().get(
      routes.urlBuscarNotaCliente(invoice_number, delivery_step_id),
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function assocNotaFiscalClienteWithDeliveryStep(delivery_step_id, invoice_id) {
  try {
    const response = await authHttp().post(routes.urlAssocNotaFiscalClienteWithDeliveryStep, {
      delivery_step_id,
      invoice_id,
    })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function newAssocNotaFiscalClienteWithDeliveryStep(
  delivery_step_id,
  invoice_number,
  invoice_path,
) {
  try {
    const response = await authHttp().post(routes.urlNewAssocNotaFiscalClienteWithDeliveryStep, {
      delivery_step_id,
      invoice_path,
      invoice_number,
    })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getMissingProductByDeliveryId(delivery_id) {
  try {
    const response = await authHttp().get(routes.urlGetMissingProductByDeliveryId(delivery_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function associarNotaFiscalClienteComItems(invoice_id, missing_product_ids) {
  try {
    const response = await authHttp().post(routes.urlAssociarNotaFiscalClienteComItems, {
      invoice_id,
      missing_product_ids,
    })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function ocorrenciasPorEntrega(delivery_id) {
  try {
    const response = await authHttp().get(routes.urlOcorrenciasPorEntrega(delivery_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function palletAreaPorEntrega(delivery_id) {
  try {
    const response = await authHttp().get(routes.urlPalletAreaPorEntrega(delivery_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function associarDevolucaoParcialOrdemColeta(deliveries_ids, ordemcoleta_id, tp_id) {
  try {
    const response = await authHttp().post(routes.urlAssociarDevolucaoParcialOrdemColeta, {
      deliveries_ids,
      ordemcoleta_id,
      tp_id,
    })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function desassociarDevolucaoParcialOrdemColeta(deliveries_ids) {
  try {
    const response = await authHttp().post(routes.urlDesassociarDevolucaoParcialComOrdemColeta, {
      deliveries_ids,
    })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function associarDevolucaoTotalOrdemColeta(deliveries_ids, ordemcoleta_id) {
  try {
    const response = await authHttp().post(routes.urlAssociarDevolucaoTotalOrdemColeta, {
      deliveries_ids,
      ordemcoleta_id,
    })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function desassociarDevolucaoTotalOrdemColeta(deliveries_ids) {
  try {
    const response = await authHttp().post(routes.urlDesassociarDevolucaoTotalComOrdemColeta, {
      deliveries_ids,
    })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function associarSobraOrdemColeta(ordemcoleta_id, leftover_product_ids) {
  try {
    const response = await authHttp().post(urlAssociarSobraComOrdemColeta, {
      ordemcoleta_id,
      leftover_product_ids,
    })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function desassociarSobraOrdemColeta(leftover_product_ids) {
  try {
    const response = await authHttp().post(urlDesassociarSobraComOrdemColeta, {
      leftover_product_ids,
    })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getSobrasPendentes(tp_id, company_id, pInicial, pFinal) {
  try {
    const response = await authHttp().get(
      routes.urlGetSobrasPendentes(tp_id, company_id, pInicial, pFinal),
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getSobrasAssociadas(ordemcoleta_id) {
  try {
    const response = await authHttp().get(routes.urlGetSobrasAssociadas(ordemcoleta_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function ajustarQuantidadeSobras(
  qte_adjusted,
  adjust_justification,
  leftover_product_id,
) {
  try {
    const response = await authHttp().put(urlAjustarQuantidadeSobra, {
      qte_adjusted,
      adjust_justification,
      leftover_product_id,
    })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getClientInvoices(delivery_id) {
  try {
    const response = await authHttp().get(routes.urlGetClientInvoices(delivery_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

// ***** Local de Descarga *****
export async function getLocaisDescarga(operationcenter_id) {
  try {
    const response = await authHttp().get(routes.urlGetLocaisDescarga(operationcenter_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function saveLocalDescarga({ name, activated, operationcenter_id, id = null }) {
  try {
    let response
    if (id) {
      response = await authHttp().put(urlLocalDescarga, { name, activated, operationcenter_id, id })
    } else {
      response = await authHttp().post(urlLocalDescarga, { name, activated, operationcenter_id })
    }
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

// ***** Aprovacao Ordem Coleta *****
export async function getOrdensColetasParaAprovacao() {
  try {
    const tp_ids = getTps().map(t => t.id)
    const company_ids = getEmpresas().map(e => e.id)
    const response = await authHttp().get(urlGetOrdensColetaParaAprovar(tp_ids, company_ids))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function aprovarOrdemColeta(ordemcoleta_id) {
  try {
    const response = await authHttp().put(urlAprovarOrdemColeta(ordemcoleta_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function solicitarCorrecaoOrdemColeta(ordemcoleta_id, justificativa_correcao) {
  try {
    const response = await authHttp().put(urlSolicitarCorrecaoOrdemColeta, {
      ordemcoleta_id,
      justificativa_correcao,
    })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function downloadNfDevolucaoTotal(ordemcoleta_id) {
  try {
    await downloadZipFile(
      urlDownloadNfDevolucaoTotal(ordemcoleta_id),
      `oc_${ordemcoleta_id}_nf_dev_total.zip`,
    )
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function downloadNfDevolucaoParcial(ordemcoleta_id) {
  try {
    await downloadZipFile(
      urlDownloadNfDevolucaoParcial(ordemcoleta_id),
      `oc_${ordemcoleta_id}_nf_dev_parcial.zip`,
    )
  } catch (error) {
    throw errorHandler(error)
  }
}

// ****** Análise das Ocorrências ***** //
export async function getInfoForAnaliseDasOcorrenciasPanel(
  user_id,
  tp_id,
  company_id,
  p_inicial,
  p_final,
) {
  try {
    const response = await authHttp().get(
      urlGetInfoForAnaliseDasOcorrencias(user_id, tp_id, company_id, p_inicial, p_final),
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

// ****** Ocorrências Por Colaboradores ***** //
export async function getOcorrenciaPorColaboradores(company_id, tp_id, p_inicial, p_final) {
  try {
    const url = routes.urlGetOcorrenciaPorColaboradores(company_id, tp_id, p_inicial, p_final)
    const response = await authHttp().get(url)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

// ****** Conferencia Ordem de Coleta ***** //
export async function createConferenciaOrdemColeta(ordem_coleta_id) {
  try {
    const url = routes.urlcreateConferenciaOrdemColeta(ordem_coleta_id)
    const response = await authHttp().post(url)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function historicoConferenciaOrdemColeta(ordem_coleta_id) {
  try {
    const url = routes.urlHistoricoConferenciaOrdemColeta(ordem_coleta_id)
    const response = await authHttp().get(url)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
